import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpModule } from '@angular/http';

import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from './shared/shared.module';
import { LoginModule } from './login/login.module';
import { AdminModule } from './admin/admin.module';
import { AssessmentsModule } from './assessments/assessments.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ThemeModule } from "./theme/theme.module";
import { ReportsModule } from "./reports/reports.module";
import { CompaniesModule } from "./companies/companies.module";
import { ToastModule } from 'ng-mdb-pro/pro/alerts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MDBBootstrapModules } from 'ng-mdb-pro';
import { HelpComponent } from './help/help.component';
import { AccountOwnerSettingsComponent } from './account-owner-settings/account-owner-settings.component';
import { BaaComponent } from './baa/baa.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HelpComponent,
    AccountOwnerSettingsComponent,
    BaaComponent,
    PrivacyComponent,
    TermsAndConditionsComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    HttpModule,
    SharedModule.forRoot(),
    MDBBootstrapModules.forRoot(),
    AdminModule,
    AssessmentsModule,
    LoginModule,
    ReportsModule,
    ThemeModule,
    CompaniesModule,
    AppRoutingModule,
  ], 
  schemas: [ NO_ERRORS_SCHEMA ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts